// Pure derivation of how the notification stack is laid out. Kept separate from
// the container component so the collapse/expand transitions are unit-testable,
// mirroring utils/updateToastState.js.
//
// Inputs:
//   notifications - app-state array of { id, message, type, duration }, oldest-first
//   limit         - max toasts shown before the stack collapses (VISIBLE_LIMIT)
//   expanded      - whether the user has expanded a collapsed stack
//
// Returns { mode, topItems, hiddenItems, extraCount }, all items newest-first.
//   topItems    - rendered fully and visibly
//   hiddenItems - kept MOUNTED (so their auto-dismiss timers keep running) but
//                 visually collapsed behind the "+N more" affordance
export function getNotificationLayout(notifications, { limit, expanded }) {
  const newestFirst = [...notifications].reverse();

  if (newestFirst.length <= limit) {
    return { mode: 'list', topItems: newestFirst, hiddenItems: [], extraCount: 0 };
  }

  if (expanded) {
    return { mode: 'expanded', topItems: newestFirst, hiddenItems: [], extraCount: 0 };
  }

  const visibleCount = limit - 1;
  const topItems = newestFirst.slice(0, visibleCount);
  const hiddenItems = newestFirst.slice(visibleCount);
  return { mode: 'collapsed', topItems, hiddenItems, extraCount: hiddenItems.length };
}
